export default "__VITE_ASSET__BXvhEC$e__"